import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  datePicker: {
    display: 'inline-block'
  },
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  table: {
    boxShadow: 'none',
    '& .MuiTable-root': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '& .MuiTableCell-root': {
      padding: '16px 10px',
      '& + &': {
        paddingLeft: '20px'
      }
    },
    '& .MuiTableRow-head': {
      borderBottomWidth: '1px'
    },
    '& .MuiTableBody-root tr:first-of-type td': {
      paddingTop: '16px'
    },
    '& .MuiTableBody-root tr:last-of-type td': {
      paddingBottom: '16px'
    },
    '& .MuiTableRow-root td:first-of-type': {
      color: palette.shades[800]
    }
  },
  cellXs: {
    width: '90px'
  },
  utility: {
    backgroundColor: palette.shades[100],
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '2px',
    '& + &': {
      marginTop: '10px'
    }
  },
  utilityTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  utilityIcon: {
    margin: '0 10px'
  },
  unitForms: {
    padding: '32px 40px',
    backgroundColor: palette.shades[200],
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  paperContent: {
    padding: '32px 40px'
  },
  unitsCounter: {
    display: 'flex',
    alignContent: 'center',
    marginTop: '24px',
    '& .MuiButton-actionIcon': {
      padding: '12px',
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px'
      }
    }
  },
  unitsCounterInput: {
    width: '120px',
    margin: '0 10px'
  },
  address: {
    padding: '26px 40px',
    boxShadow: palette.shadows.light
  },
  validationCaption: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200]
  },
  unitSearch: {
    maxWidth: '400px'
  },
  unitFormsPercentageShare: {
    marginBottom: '16px',
    '& .MuiChip-root': {
      display: 'flex',
      marginBottom: '16px',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }
}));
export default useStyles;